import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  Form,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  FormGroup,
  Label,
  FormFeedback,
} from 'reactstrap'
import { withFormik, Field } from 'formik'
import * as Yup from 'yup'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

import CardTitle from 'components/ui/CardTitle/CardTitle'
import { renderHelpText, renderField } from 'core/utils/formik'

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
}

const toolbar = {
  options: [
    'inline',
    'blockType',
    'fontSize',
    'list',
    'textAlign',
    'remove',
    'history',
  ],
}

class ReportSettingsForm extends React.Component {
  constructor(props) {
    super(props)
    const { footer } = this.props.initialValues
    const contentBlock = htmlToDraft(footer)
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      )
      const editorState = EditorState.createWithContent(contentState)
      this.state = {
        editorState,
      }
    }
  }

  handleEditorChange = (field, form, editorState) => {
    editorState = editorState || ''
    this.setState({ editorState })
    form.setFieldValue(
      field.name,
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
    )
  }

  renderFooterEditor = ({ field, form }) => {
    const { name } = field
    const { errors, touched } = form
    const { editorState } = this.state

    return (
      <FormGroup color={touched[name] && errors[name] ? 'danger' : ''}>
        <Label for="footer">Footer</Label>
        <Editor
          editorState={editorState}
          onEditorStateChange={(newEditorState) =>
            this.handleEditorChange(field, form, newEditorState)
          }
          toolbar={toolbar}
        />
        {touched[name] && errors[name] && (
          <FormFeedback>{errors[name]}</FormFeedback>
        )}
        {renderHelpText(
          <span>Text will be added to the bottom of each consumer report.</span>
        )}
      </FormGroup>
    )
  }

  render() {
    const { handleSubmit, isSubmitting, isValid } = this.props

    return (
      <Card className="pageCard ReportSettingsForm">
        <Form onSubmit={handleSubmit}>
          <CardHeader>
            <CardTitle>Consumer Report Settings</CardTitle>
          </CardHeader>
          <CardBody className="padded">
            <Field
              name="pcil_chart_enabled"
              type="switch"
              component={renderField}
              label="Enable pCi/L Chart"
              helpText="Toggles visibility of pCi/L chart"
            />

            <Field
              name="default_notice_text"
              type="switch"
              component={renderField}
              label="Enable Default State Notice Text"
              helpText="Toggles visibility of default state notice text"
            />

            <Field name="footer" component={this.renderFooterEditor} />
          </CardBody>
          <CardFooter>
            <Button
              type="submit"
              color="primary"
              disabled={!isValid || isSubmitting}
            >
              Save
            </Button>
          </CardFooter>
        </Form>
      </Card>
    )
  }
}

ReportSettingsForm = withFormik({
  mapPropsToValues: ({ initialValues }) =>
    Object.assign(
      {
        pcil_chart_enabled: true,
        default_notice_text: true,
        footer: '',
      },
      initialValues
    ),
  validationSchema: Yup.object().shape({
    pcil_chart_enabled: Yup.boolean(),
    default_notice_text: Yup.boolean(),
    footer: Yup.string().required('Required'),
  }),
  handleSubmit: (values, formikBag) => {
    const {
      setSubmitting,
      props: { onSubmit },
    } = formikBag
    onSubmit(values, setSubmitting)
  },
  isInitialValid: () => true,
})(ReportSettingsForm)

ReportSettingsForm.propTypes = propTypes

export default ReportSettingsForm



// WEBPACK FOOTER //
// ./src/features/Account/ReportSettingsContainer/ReportSettingsForm.js